import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ICv} from '../../interfaces/cv';
import {lastValueFrom, Observable} from 'rxjs';
import {ServiceNames} from '../../interfaces/my7n-env-config';
import {AppConfigService} from '../app-config.service';
import {ICvListItem} from '../../interfaces/cv-list-item';

@Injectable()
export class CvListService {
  readonly API_CV: string;

  constructor(private http: HttpClient,
              private appConfigService: AppConfigService) {
    this.API_CV = appConfigService.serviceUrl(ServiceNames.Cv, 'v1') + 'cv';
  }

  /**
   * Returns primary CV data.
   *
   * @returns {Observable<ICv>}
   */
  getPrimaryCv(): Observable<ICv> {
    return this.http.get<ICv>(`${this.API_CV}/primary`);
  }

  /**
   * Returns a list of CVs
   * @returns {Promise<Array<ICvListItem>>}
   */
  getCvList(): Promise<Array<ICvListItem>> {
    return lastValueFrom(this.http.get<Array<ICvListItem>>(`${this.API_CV}/list`));
  }
}
